
import React from 'react';
import { Loader } from '@/components/ui/loader';

interface PopularSearchesProps {
  isLoading: boolean;
  popularSearches: string[];
  onSearchClick: (term: string) => void;
}

const PopularSearches: React.FC<PopularSearchesProps> = ({
  isLoading,
  popularSearches,
  onSearchClick
}) => {
  return (
    <div className="flex flex-wrap justify-center gap-3 mt-4 text-sm text-muted-foreground">
      <span className="opacity-80">Popular:</span>
      {isLoading ? (
        <Loader size="sm" className="ml-2" />
      ) : (
        popularSearches.map((term, index) => (
          <button 
            key={`popular-${index}`}
            className="underline-offset-4 hover:underline text-primary dark:text-accent hover:text-primary/80 transition-all hover:translate-y-[-1px]"
            onClick={() => onSearchClick(term)}
          >
            {term}
          </button>
        ))
      )}
    </div>
  );
};

export default PopularSearches;
